module.exports = __webpack_public_path__ + "static/media/BSP2.37e2048f.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/BSP2.png
// module id = 890
// module chunks = 0